import { CloudMetricClient } from '@sbercloud/ft-metrics-client';
import { gtmId, testYmId, ymId } from 'src/global';

const getCorrectYmId = () => {
  return process.env.NEXT_PUBLIC_SPACE === 'production' ? [ymId] : [testYmId];
};

const metricClient = new CloudMetricClient({
  yandexMetricaIds: getCorrectYmId(),
  googleAnalyticsId: gtmId,
});

export { metricClient };
